import React from 'react';
import Header from './Header';
import bgtrace from '../assets/bgtrace1.jpeg';

export default function PolicyWrapper({ title, subtitle, children }) {
  return (
    <div 
      className="min-h-screen w-full"
      style={{
        backgroundImage: `url(${bgtrace})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        backgroundAttachment: 'fixed'
      }}
    >
      <Header />
      
      <div className="text-center pt-20 pb-10">
        <h1 className="text-5xl font-extrabold">
          {title} <span className="text-red-600">{subtitle}</span>
        </h1>
      </div>

      <div className="max-w-4xl mx-auto bg-white/95 text-gray-900 shadow-xl rounded-xl p-10 mt-4 mb-20 backdrop-blur-sm">
        {children}
      </div>
    </div>
  );
}

